module.exports = __webpack_public_path__ + "img/setting-2.9c4571dc.png";